import da from './da.json'
import de from './de.json'
import en from './en.json'
import es from './es.json'
import fi from './fi.json'
import fr from './fr.json'
import it from './it.json'
import ko from './ko.json'
import nl from './nl.json'
import pl from './pl.json'
import sv from './sv.json'
import zh from './zh.json'

import type { TranslationsByLanguage } from '@susu/i18n'

/**
 * Languages the hub renders in — every locale file Crowdin ships into this
 * folder.
 *
 * Registering is what makes a file reachable: `createI18n` falls back to `en`
 * for any language not listed here, so a shipped-but-unregistered file renders
 * silently in English. Keys are the two-letter codes `CustomerHubCore` derives
 * from `document.documentElement.lang`, which is why Crowdin's `zh-CN` is `zh`.
 *
 * Partially translated files are safe to register: `translate` looks a key up
 * in the active language before the fallback, so an **absent** key shows
 * English. Every language happens to be complete on this branch.
 *
 * An **empty** value is not the same as an absent one — `translate` returns the
 * key itself for it, not the English copy. Crowdin writes `""` instead of
 * omitting a key whenever the export is nested, so an untranslated nested key
 * reaches the screen as its own dot path unless the call site guards for it by
 * comparing `t(key) === key`.
 */
export const translations: TranslationsByLanguage = {
  da,
  de,
  en,
  es,
  fi,
  fr,
  it,
  ko,
  nl,
  pl,
  sv,
  zh,
}
